import { useEffect } from "react";

export interface ToastState {
  message: string;
  /** Rendered as an "Undo" button when present. */
  undo?: () => void | Promise<void>;
}

const DISMISS_AFTER_MS = 6000;

/**
 * Action feedback, using the design's `.toast`.
 *
 * Archiving and deleting are the two things people do fastest and regret most,
 * so both offer an undo here rather than sending the user to hunt through Trash.
 */
export function Toast({ toast, onDismiss }: { toast: ToastState; onDismiss: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, DISMISS_AFTER_MS);
    return () => window.clearTimeout(timer);
    // Re-arm whenever the message changes, so a second action gets a full window
    // instead of inheriting the remainder of the first.
  }, [toast, onDismiss]);

  return (
    <div className="toast on" role="status" aria-live="polite">
      <span>{toast.message}</span>
      {toast.undo && (
        <button
          onClick={() => {
            void toast.undo?.();
            onDismiss();
          }}
        >
          Undo
        </button>
      )}
    </div>
  );
}
